module.exports = __webpack_public_path__ + "img/biosteam-logo.4ae393ca.svg";